import { Injectable } from '@angular/core';
import { AuthStorageService, AuthToken } from '@spartacus/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { Observable, filter, of, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenIdleService {
  constructor(private authStorageService: AuthStorageService, private bnIdle: BnNgIdleService) {}

  userTokenExpiration(): Observable<boolean> {
    return this.authStorageService.getToken().pipe(
      filter((token: AuthToken) => !!token?.expires_at),
      switchMap((token: AuthToken) => {
        const expiresInMs = +token.expires_at - Date.now();
        const timeoutInSeconds = Math.floor(expiresInMs / 1000);

        if (timeoutInSeconds <= 0) {
          return of(true);
        }
        return this.bnIdle.startWatching(timeoutInSeconds).pipe(take(1));
      })
    );
  }

  stopMonitoringToken() {
    this.bnIdle.stopTimer();
  }

  resetTokenExpiration() {
    this.bnIdle.resetTimer(0);
  }
}
